import { call, put, select } from 'redux-saga/effects';

import { goToSiteService } from './router';
import {
  createDeviceRequest,
  deleteDeviceRequest,
  updateDeviceRequest,
  hideDeviceRequest,
  fetchRealtimeDatasRequest,
  updateDeviceCommonRequest,
} from '../requests';
import { nextDevicePositionSelector, pathSelector } from '../../../selectors';
import {
  createDevice,
  deleteDevice,
  updateDevice,
  updateDeviceCommon,
  hideDevice,
  closeModal,
} from '../../../actions';

export function* createDeviceService(data) {
  const nextData = {
    ...data,
  };

  yield put(
    createDevice({
      ...nextData,
    }),
  );

  const { success } = yield call(createDeviceRequest, nextData);

  if (success) {
    yield put(closeModal());
  }
}

export function* updateDeviceService(id, data) {
  const updateData = {
    ...data,
  };
  if (data.isCreate === true) {
    updateData.position = yield select(nextDevicePositionSelector, data.lineId);
  }

  yield put(updateDevice(id, updateData));
  yield call(updateDeviceRequest, id, updateData);
}

export function* updateDeviceCommonService(id, data) {
  const updateData = {
    ...data,
  };
  if (data.isCreate === true) {
    updateData.position = yield select(nextDevicePositionSelector, data.lineId);
  }

  yield put(updateDeviceCommon(id, updateData));
  yield call(updateDeviceCommonRequest, id, updateData);
}

export function* hideDeviceService(id) {
  yield put(hideDevice(id));
  yield call(hideDeviceRequest, id);
}

export function* updateCurrentDeviceService(data) {
  const { deviceId } = yield select(pathSelector);

  yield call(updateDeviceService, deviceId, data);
}

export function* moveDeviceService(id, lineId, index) {
  const position = yield select(nextDevicePositionSelector, lineId, index, id);

  yield call(updateDeviceService, id, {
    lineId,
    position,
  });
}

export function* moveCurrentDeviceService(lineId, index) {
  const { deviceId } = yield select(pathSelector);

  yield call(moveDeviceService, deviceId, lineId, index);
}

export function* transferDeviceService(id, siteId, lineId, index) {
  const { deviceId: currentDeviceId, siteId: currentSiteId } = yield select(pathSelector);
  const position = yield select(nextDevicePositionSelector, lineId, index, id);

  if (id === currentDeviceId) {
    yield call(goToSiteService, currentSiteId);
  }

  yield put(deleteDevice(id));

  yield call(updateDeviceRequest, id, {
    siteId,
    lineId,
    position,
  });
}

export function* transferCurrentDeviceService(siteId, lineId, index) {
  const { deviceId } = yield select(pathSelector);

  yield call(transferDeviceService, deviceId, siteId, lineId, index);
}

export function* deleteDeviceService(id) {
  const { deviceId, siteId } = yield select(pathSelector);

  if (id === deviceId) {
    yield call(goToSiteService, siteId);
  }

  yield put(deleteDevice(id));
  yield call(deleteDeviceRequest, id);
}

export function* deleteCurrentDeviceService() {
  const { deviceId } = yield select(pathSelector);

  yield call(deleteDeviceService, deviceId);
}

export function* fetchRealtimeDatasService() {
  yield call(fetchRealtimeDatasRequest);
}
